import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DataInvoice from './DataInvoice';
import DataOrder from './DataOrder';
import { picState } from '../../features/pic/picSlice';
import DetailOrder from './DetailOrder';
import DetailInvoice from './DetailInvoice';
import DateRangeSiberat from '../../components/DateRange';
import moment from 'moment';
import usePageTitle from '../../hooks/usePageTitle';

const Dashboard = () => {
  usePageTitle('Dashboard');
  const { user } = useSelector(state => state.auth);
  const pic = useSelector(picState);
  const [params, setParams] = useState({
    from_date: null,
    to_date: null,
    branch: null
  });

  useEffect(() => {
    if (isNaN(pic)) {
      setParams({
        from_date: null,
        to_date: null
      });
      return;
    }
    setParams(prevState => ({
      ...prevState,
      branch: pic
    }));
  }, [pic]);

  return (
    <main className='dashboard-page p-4 sm:p-5 space-y-6'>
      <div className='dashboard-page__header'>
        <div>
          <h1 className='dashboard-page__title'>Dashboard</h1>
          {user?.data?.name && (
            <p className='dashboard-page__welcome'>
              Selamat datang, {user.data.name}
            </p>
          )}
        </div>
        <DateRangeSiberat
          value={`${
            params.from_date
              ? moment(params.from_date).format('D MMM')
              : moment().startOf('month').format('D MMM')
          } - ${
            params.to_date
              ? moment(params.to_date).format('D MMM YYYY')
              : moment().format('D MMM YYYY')
          }`}
          start='from_date'
          end='to_date'
          params={params}
          setParams={setParams}
        />
      </div>

      <section>
        <h2 className='dashboard-section-title'>Ringkasan</h2>
        <div className='dashboard-summary-grid'>
          <DetailOrder params={params} />
          <DetailInvoice params={params} />
        </div>
      </section>

      <section>
        <h2 className='dashboard-section-title'>Aktivitas</h2>
        <div className='dashboard-activity-grid'>
          <DataOrder params={params} />
          <DataInvoice />
        </div>
      </section>
    </main>
  );
};

export default Dashboard;
